import { useQuery } from "@tanstack/react-query";
import { AIAgentSuggestions } from "@graylog/enterprise-api";
import { SUGGESTIONS_QUERY_KEY } from "../api/Suggestions";
const fetchSuggestions = (status) => AIAgentSuggestions.list(status);
const useEventDefinitionSuggestions = (status = "suggested") => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [...SUGGESTIONS_QUERY_KEY, status],
    queryFn: () => fetchSuggestions(status),
    notifyOnChangeProps: ["data", "error"]
  });
  return { data, isLoading, error, refetch };
};
export default useEventDefinitionSuggestions;
